/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Faq_Credits_AInputs */

const en_road_dude_faq_credits_a = /** @type {(inputs: Road_Dude_Faq_Credits_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, the examples and prompts are available on this page. Creating a new clip uses the generator’s credits, which are shown before you submit.`)
};

const zh_road_dude_faq_credits_a = /** @type {(inputs: Road_Dude_Faq_Credits_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`看案例和复制提示词不消耗积分。提交新视频时，生成器会在按钮旁显示所需积分。`)
};

/**
* | output |
* | --- |
* | "Yes, the examples and prompts are available on this page. Creating a new clip uses the generator’s credits, which are shown before you submit." |
*
* @param {Road_Dude_Faq_Credits_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_faq_credits_a = /** @type {((inputs?: Road_Dude_Faq_Credits_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Faq_Credits_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_faq_credits_a(inputs)
	return zh_road_dude_faq_credits_a(inputs)
});
export { road_dude_faq_credits_a as "road_dude.faq.credits.a" }